import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import type { PriceImportRun } from './types';
import { priceImportsEndpointIdentifier } from './use-get-price-import-runs-api';

/**
 * The slow call: resolve the column mapping, apply it to every row, and match
 * each row against the master catalogue. Seconds, not milliseconds.
 */
type TData = { data: PriceImportRun };
type TError = AxiosError;
type TVariables = { runId: number };
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useAdaptPriceImportRunApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ runId }: TVariables) => {
    try {
      const { data } = await http.post(`${priceImportsEndpointIdentifier}/${runId}/adapt`);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: [`${priceImportsEndpointIdentifier}/adapt`],
    retry: false,
    ...options,
  });
}
